import {AcsTransactionResult} from '../types/TransactionResult'

export const redirectToAcs = (result: AcsTransactionResult) => {
    const form = document.createElement('form')

    form.method = 'POST'
    form.action = '/acs/redirect'

    const params = {
        acsUrl: result.acsUrl,
        paReq: result.paReq,
        md: result.md,
        termUrl: `${window.location.origin}/acs/term-url`
    }

    Object.entries(params).forEach(([key, value]) => {
        const input = document.createElement('input')

        input.type = 'hidden'
        input.name = key
        input.value = value

        form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
}
